import * as React from "react";
import { ContextMenu, MenuItem, } from "react-contextmenu";
import { ThunkDispatch } from "redux-thunk";
import { dialogActions } from "../actions/dialog.actions";
import { compose } from 'redux';
import { connect } from 'react-redux';
import { ColumnType } from "./PhasePlan/Column";
import { lookaheadActions } from "../actions/lookahead.actions";
import { getSelectedTagSet } from "../selectors/lookahead.selector";
import { entityActions } from "../actions/entity.actions";

const _ = require("lodash");



interface Props {
    duplicateTradesValue: (tagIds: string[]) => Promise<void>;
    deleteTagValue: (tradeIds :string[]) => Promise<void>;
    copyTags: (tagIds: string[],  type: ColumnType) => Promise<void>;
    selectedTags: Set<string>
}


const TradeContextMenu: React.FC<Props> = ({  duplicateTradesValue, deleteTagValue, selectedTags}) => {
    const handleTagContextMenuClick = (e:any, data:any, target:any) => {
        const arraySelectTrades = !!selectedTags ? [...selectedTags] : []

        const tagId = target.getAttribute('tradeId')
        if(!!tagId) {
            arraySelectTrades.push(tagId)
        }

        const byUniqueSelectedTags = _.uniq(arraySelectTrades)
        switch(data.action) {
            case 'Duplicate':
                duplicateTradesValue( byUniqueSelectedTags)
            
                break;
            case 'Delete':
                deleteTagValue( byUniqueSelectedTags)
                break;
        }
    }

    return(
        <React.Fragment>
            <ContextMenu id="trade_context_menu">
                <MenuItem data={{ action: 'Duplicate' }} onClick={handleTagContextMenuClick} >
                    Duplicate
                </MenuItem>
                <MenuItem divider />
                <MenuItem data={{ action: 'Delete' }} onClick={handleTagContextMenuClick} >
                    Delete
                </MenuItem>
            </ContextMenu>
        </React.Fragment>
    )
}

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {
    return {
        deleteTagValue: (tradeIds:string[]) => dispatch(entityActions.deleteTrade(_.uniq(tradeIds))),
        duplicateTradesValue: ( tradeIds:string[] ,type:ColumnType) => dispatch(entityActions.duplicateTrade(_.uniq(tradeIds), type)),
    }
}

const mapStateToProps = (state:any, ownProps?: any) => ({
    selectedTags: new Set<string>()
})

export default compose<React.ComponentClass>(
    connect(mapStateToProps, mapDispatchToProps),
    
)(TradeContextMenu)




// WEBPACK FOOTER //
// ./src/components/TradeContextMenu.tsx